/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Notification } from './notification';

/**
 * Queue of notification items
 */
@Component({
  standalone: false,
  selector: 'gh-notification-queue',
  templateUrl: 'notification-queue.component.html',
  styleUrls: ['notification-queue.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationQueueComponent {
  @Input() items: Notification[] = [];
}
